import { Sparkles, FileText, Search } from 'lucide-react';
import { SectionPageEditor } from '@/components/admin/SectionPageEditor';
import type { SectionDef, TextFieldDef } from '@/components/admin/SectionPageEditor';

// pages/privacy-policy/page.tsx is 6 numbered sections, each a plain
// title+body pair (verified directly against the page's `sections`
// array) — generated below rather than hand-listed. All 15 keys
// (3 hero + 12 section) are live, no orphans. No images on this page.
// One "Legal Content" block instead of 6 separate toggleable sections —
// individual clauses within one legal document aren't something a
// business owner would show/hide independently.
function legalSections(namespace: string, count: number): TextFieldDef[] {
  const fields: TextFieldDef[] = [];
  for (let i = 1; i <= count; i++) {
    fields.push({ key: `${namespace}.section${i}.title`, label: `Section ${i} — Title` });
    fields.push({ key: `${namespace}.section${i}.body`, label: `Section ${i} — Body`, long: true });
  }
  return fields;
}

const PRIVACY_SECTIONS: SectionDef[] = [
  {
    key: 'hero',
    title: 'Hero',
    icon: Sparkles,
    texts: [
      { key: 'privacy.hero.label', label: 'Eyebrow Label' },
      { key: 'privacy.hero.heading', label: 'Heading' },
      { key: 'privacy.lastUpdated', label: 'Last Updated Text' },
    ],
  },
  {
    key: 'legalContent',
    title: 'Legal Content (6 sections)',
    icon: FileText,
    texts: legalSections('privacy', 6),
  },
  {
    key: 'seo',
    title: 'SEO',
    icon: Search,
    note: 'Shown in Google search results and social media link previews — not visible on the page itself.',
    texts: [
      { key: 'seo.privacy.title', label: 'Meta Title', long: true },
      { key: 'seo.privacy.description', label: 'Meta Description', long: true },
    ],
  },
];

export default function AdminPrivacyPage() {
  return <SectionPageEditor pageKey="privacy" title="Privacy Policy" sections={PRIVACY_SECTIONS} />;
}
